var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "claim-start-card" }, [
    _vm._m(0),
    _c("div", { staticClass: "custom-control custom-radio mb-2" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localValue,
            expression: "localValue"
          }
        ],
        staticClass: "custom-control-input",
        attrs: { id: `${_vm.name}-auto`, name: _vm.name, type: "radio" },
        domProps: { value: true, checked: _vm._q(_vm.localValue, true) },
        on: {
          change: function($event) {
            _vm.localValue = true
          }
        }
      }),
      _c(
        "label",
        {
          staticClass: "custom-control-label",
          attrs: { for: `${_vm.name}-auto` }
        },
        [
          _c("strong", [_vm._v("Automática:")]),
          _vm._v(
            " Se generará batch de todos los servicios elegibles a reclamar. "
          )
        ]
      )
    ]),
    _c("div", { staticClass: "custom-control custom-radio mb-3" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localValue,
            expression: "localValue"
          }
        ],
        staticClass: "custom-control-input",
        attrs: { id: `${_vm.name}-manual`, name: _vm.name, type: "radio" },
        domProps: { value: false, checked: _vm._q(_vm.localValue, false) },
        on: {
          input: function($event) {
            return _vm.$emit("is-automatic", false)
          },
          change: function($event) {
            _vm.localValue = false
          }
        }
      }),
      _c(
        "label",
        {
          staticClass: "custom-control-label",
          attrs: { for: `${_vm.name}-manual` }
        },
        [
          _c("strong", [_vm._v("Manual:")]),
          _vm._v(
            " Deberá seleccionar manualmente los servicios que desea enviar a reclamación. "
          )
        ]
      )
    ]),
    _vm._m(1),
    _c(
      "div",
      { staticClass: "d-flex justify-content-end mt-3" },
      [
        _c("action-button", {
          attrs: {
            i: "fas fa-times-circle",
            text: "Cancelar",
            variant: "outline-danger mr-3 pl-3 pr-4"
          },
          on: {
            click: function($event) {
              return _vm.$emit("cancel")
            }
          }
        }),
        _c("action-button", {
          attrs: {
            i: "fas fa-chevron-circle-right",
            text: _vm.localValue ? "Concluir" : "Continuar",
            variant: "success pl-3 pr-4"
          },
          on: {
            click: function($event) {
              return _vm.$emit("confirm", _vm.localValue)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "claim-start-card__header mb-3" }, [
      _c("span", { staticClass: "claim-start-card__badge" }, [
        _c("span", { staticClass: "claim-start-card__badge-icon" })
      ]),
      _c("span", { staticClass: "claim-start-card__title" }, [
        _vm._v("Comenzar Reclamación")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "alert alert-warning rounded border border-danger font-weight-bold claim-start-card__alert",
        attrs: { role: "alert" }
      },
      [
        _c("i", { staticClass: "fas fa-bell-exclamation mr-2" }),
        _vm._v(
          " Se creará un registro de Batch por cada Lugar de Servicio elegible. "
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }